import Client from "../../Client";
import Exceptions from "../../Exceptions";
import { wait } from "../../misc/date";
import { downloadAnnualAttractionReport, downloadAnnualReport, downloadMonthlyLGUReport } from "../../services/api/data/sameday/published";
import { getAttractionList, getLGUList, getProvinceList } from "../../services/api/meta";
import { AlertDrawerController } from "../../views/sections/sidebar/AlertDrawer";
import { Notifier } from "../conductor";

export class SameDayReportsController {
    constructor(options) {

        /** @type {{ lgu: string, id: string }} */
        this.reference = options.ref;

        const self = this;        
        this.notifiers = {
            ready: new Notifier(false),
            unauthorized: new Notifier(false),
            attractions: {
                loading: new Notifier(false),
                loaded: new Notifier()
            },
            downloading: {
                report1: new Notifier(),
                report2: new Notifier(),
                report3: new Notifier()
            },
            alert: new AlertDrawerController()
        };

        this.status = {
            get ready() { return self.notifiers.ready.get() },
            get reloading() { return self.notifiers.reloading.get() },
            get unauthorized() { return self.notifiers.unauthorized.get() },
            attractions: {
                get loading() { return self.notifiers.attractions.loading.get() }
            }
        };

        this.data = { attractions: [] };
      

        this.initialize();
    }

    async initialize() {
        Client.ensureSignedIn();
        if(this.isInitialized) return; this.isInitialized = true;

        try {            
            this.collection = {
                province: listToCollection(await getProvinceList()),
                lgu: listToCollection(await getLGUList())
            };

            this.reference.global = {};

            const account = Client.account;
            if(account.role === "lgu") {
                this.reference.global.lguFixed = true;
                this.reference.global.provinceFixed = true;

                this.reference.section2.lgu = account.role_specific;
                this.reference.attractions.lgu = account.role_specific;

                const province = this.collection.lgu[account.role_specific].province;
                this.reference.attractions.province = province;
                this.reference.section2.province = province;
            } else if(account.role === "province") {
                this.reference.global.provinceFixed = true;

                this.reference.section2.province = account.role_specific;
                this.reference.attractions.province = account.role_specific;
            }
            
            await this.loadAttractionsData();
        } catch(e) {
            if(e.unauthorized) return this.notifiers.unauthorized.update(true);
            else console.log(e);
        }
        
        this.notifiers.ready.update(true);
    }

    async loadAttractionsData() {
        const { province, lgu } = this.reference.attractions;
        if(lgu) {
           this.data.attractions = await getAttractionList(lgu);

           this.data.attractions.forEach(attraction => {
                if(!attraction.lgu) attraction.lgu = lgu;

                const lguId = attraction.lgu;
                const lguValues = this.collection.lgu[lguId];

                if(lguValues) {
                    const province = this.collection.province[lguValues.province];
                    attraction.location = `${lguValues.name}, ${province.name}`;
                }
           });
        }
        // const { province, month, year } = this.reference;
        // this.data = await getProvinceVisitsSubmissions({ province, month, year });
    }

    async refreshAttractions() {
        const { attractions: { loading, loaded }, alert } = this.notifiers;
        loading.update(true);
        alert.close();

        try {
            await this.loadAttractionsData();
            loaded.notify();
        } catch(e) {
            const semantics = Exceptions.getARESemantics(e);
            console.log(e);
            alert.alert(semantics.message, { status: "error", title: semantics.title, retry: () => this.refresh() });
        }

        loading.update(false);
    }
    
    async changeAttractionDate(month, year) {
        this.reference.attrations.month = month;
        this.reference.attractions.year = year;
        await this.refreshAttractions();
    }


    async downloadReport1({ year }) {
        const { report1 } = this.notifiers.downloading;
        report1.update(true);

        try {
            const filename = `VAR-${year}.xlsx`;
            await downloadAnnualReport({ year, filename });
        } catch(e) {
            const semantics = Exceptions.getARESemantics(e);
            console.log(e);
            alert.alert(semantics.message, { status: "error", title: semantics.title, retry: () => this.refresh() });
        }

        report1.update(false);
    }

    async downloadReport2({ lgu, province, month, year }) {
        const { downloading: { report2 }, alert } = this.notifiers;

        try {
            report2.update(true);

            const lguName = this.collection.lgu[lgu].name;
            const filename = `${lguName}-${month}-${year}.xlsx`;
            await downloadMonthlyLGUReport({ month, year, lgu, filename });
        } catch(e) {
            const semantics = Exceptions.getARESemantics(e);
            console.log(e);
            alert.alert(semantics.message, { status: "error", title: semantics.title, retry: () => this.refresh() });
        }


        report2.update(false);
    }

    async downloadReport3(year, attraction) {
        const { downloading: { report3 }, alert } = this.notifiers;

        try {
            report3.update(attraction);

            const attractionName = this.data.attractions.find(a => a.id === attraction).name;
            const filename = `${attractionName}-${year}.xlsx`;
            await downloadAnnualAttractionReport({ attraction, year, filename });
        } catch(e) {
            const semantics = Exceptions.getARESemantics(e);
            console.log(e);
            alert.alert(semantics.message, { status: "error", title: semantics.title, retry: () => this.refresh() });
        }


        report3.update(null);
        
    }

    async changeAttractionsLocation(province, lgu) {
        this.reference.attractions.province = province;
        this.reference.attractions.lgu = lgu;
        await this.refreshAttractions();
    }

}

function listToCollection(list) {
    const collection = {};
    for(const item of list) collection[item.id] = item;
    return collection;
} 